import { useEffect } from "react";

/**
 * Renders one or more <script type="application/ld+json"> tags in <head> and
 * cleanly removes them on unmount. Deduplicates by data-ld attribute so
 * React StrictMode double-invocations (or route re-renders) don't produce
 * duplicate schema blocks that Google would flag.
 *
 * Usage:
 *   <JsonLd blocks={[buildProductLD(product), buildBreadcrumbLD(crumbs)]} />
 */
export default function JsonLd({ blocks, id = "app-ld" }) {
  useEffect(() => {
    const valid = (blocks || []).filter(Boolean);
    if (!valid.length) return undefined;
    // Remove any previous scripts sharing this id-prefix (safety net for HMR / StrictMode).
    document
      .querySelectorAll(`script[data-ld^="${id}-"]`)
      .forEach((n) => n.parentNode && n.parentNode.removeChild(n));
    const els = valid.map((doc, i) => {
      const s = document.createElement("script");
      s.type = "application/ld+json";
      s.setAttribute("data-ld", `${id}-${i}`);
      s.text = JSON.stringify(doc);
      document.head.appendChild(s);
      return s;
    });
    return () => els.forEach((s) => s.parentNode && s.parentNode.removeChild(s));
  }, [blocks, id]);
  return null;
}
